module.exports = [{
  "config": {
    "ui": {
      "links": {
        "service": "https://xtbg-dev.jdcloud.com/protocol/service/chinese/",
        "privacy": "https://xtbg-dev.jdcloud.com/protocol/privacy/chinese/",
        "downloadUrl": "https://xtbg-dev.jdcloud.com/download"
      },
      "enableDu": true,
      "onlyMobileLogin": false,
      "canVipLogin": false,
      "canCreateTeam": false,
      "canJoinTeam": false,
      "isSpecialProjects": true,
      "isGovEbook": true,
      "enableFeedback": true,
      "enableJoyspace": true,
      "canRegister": false,
      "ebook": {
        "navs": [
          "new_contacts",
          "external_contacts",
          "tag",
          "special_projects",
          "group",
          "org",
          "my_department"
        ],
        "search": {
          "addContract": false,
          "addGroup": true
        }
      },
      "layout": {
        "nav": [
          {
            "role": "messages",
            "icon": "iconic_chat",
            "name": "layout.nav.messages"
          },
          {
            "role": "ebook",
            "icon": "iconapp_btn_addressbook",
            "name": "layout.nav.ebook"
          },
          {
            "path": "/projects",
            "role": "route",
            "icon": "iconbacklog",
            "name": "layout.nav.joywork"
          },
          {
            "role": "calendar",
            "icon": "iconic_day",
            "name": "layout.nav.calendar"
          },
          {
            "path": "/joyspace",
            "role": "route",
            "icon": "iconapp_ic_bardoc",
            "name": "layout.nav.joyspace"
          },
          {
            "role": "thirdApp",
            "icon": "iconapp_tabbar_application",
            "name": "layout.nav.thirdApp"
          }
        ]
      },
      "theme": "blue",
      "login": {
        "adCarousel": [
          "/statics/images/theme/blue/leftCenter.png"
        ],
        "description": "login.desc",
        "title": "login.title",
        "leftTopImg": "/statics/images/theme/blue/leftTop.png",
        "leftImg": "/statics/images/theme/blue/login_left.png",
        "leftBottomImg": "/statics/images/theme/blue/leftBottom.png"
      }
    },
    "environments": [
      {
        "app": {
          "entry": "https://xtbg-dev.jdcloud.com/client",
          "feedUrl": "https://jzb-oss.com/installer_releases/jdcloud_beta_x64/",
          "feedUrl32": "https://jzb-oss.com/installer_releases/jdcloud_beta_ia32/",
          "forceUpgradeVersion": "1.0.0",
          "appStoreAppKey": "b96a8ab3197544e68c9919667afe9f41",
          "withCALogin": true,
          "CALoginUrl": "https://ca.jzb.beijing.gov.cn/am/oauth2/authorize?service=initService&response_type=code&client_id=64weabwnbxxi2dsv4qxl&scope=all&redirect_uri=https://jzb.beijing.gov.cn/login/ca-callback&model=cs&decision=Allow&hotpFowardModel=mobile"
        },
        "webConfig": {
          "routeBase": "/client",
          "ssoLoginUrl": "https://xtbg-dev.jdcloud.com/passport/",
          "ssoClientId": "4d571c78c9df4830b0505b3b03dfbce5",
          "qrLoginUrl": "https://xtbg-dev.jdcloud.com/passport/"
        },
        "logConfig": {
          "logSwitch": true
        },
        "joyspace": {
          "protocol": "https",
          "wpsTarget": "public",
          "cookie": {
            "domain": ".jdcloud.com"
          },
          "host": "xtbg-dev.jdcloud.com/joyspace",
          "lowCode": {
            "createUrl": "https://joybuilder.jzb.beijing.gov.cn/#/form/create"
          },
          "canCreateSheet": true,
          "notUseOffline": true,
          "canJoyspacePreview": false,
          "pageTypes": {
              "page": {
                value: 1,
                routeTag: "document_edit"
              },
              "sheet": {
                value: 4,
                routeTag: "spreadsheet_edit"
              },
              "file": {
                value: 6,
                routeTag: "file_view"
              },
              "mind": {
                value: 10,
                routeTag: "mind"
              }
            },
            previewAllowSuffix: [
              "xls",
              "xlsx",
              "xlt",
              "et",
              "csv",
              "xlsm",
              "xltm",
              "xltx",
              "doc",
              "docx",
              "dot",
              "dotx",
              "wps",
              "wpt",
              "docm",
              "dotm",
              "ppt",
              "pptx",
              "pptm",
              "ppsx",
              "ppsm",
              "pps",
              "potx",
              "potm",
              "dpt",
              "dps",
              "pdf",
              "txt",
              "rtf",
              "ofd"
            ]
        },
        "fileService": {
          "appKey": "41d47591b3adf037",
          "imAppKey": '1mgfxqcb9nkj3f05',
          "imNoDeleteAppKey": 'tgAy7FMYQmJLUdmK',
          "groupNoticeAppKey": 'jAYNzavPLsn6aYJf',
          "hostOrigin": "https://xtbg-dev.jdcloud.com/eefs",
          "joyspaceAppKey": "966df28278a65b20",
          "calendarAppKey": 'tnevswym0az1xe91',
          "taskAppKey": 'ptntd9fids15e8nt'
        },
        "joyspaceApi": {
          "protocol": "https",
          "host": "xtbg-dev.jdcloud.com/joyspace-api"
        },
        "open": {
          "protocol": "https",
          "host": "xtbg-dev.jdcloud.com/open"
        },
        "zoom": {
          "domain": "https://jdmeeting.jd.com",
          "api": "https://api-external-joymeeting.jd-eit.com/kk/tellme",
          "sdkId": "OwcSrKQSfCpGZyf3y7YncWDAzPxhAz1j",
          "sk": "8hRfOqen*x9X3jz2KWhTI#0aAo%oe4We"
        },
        "hwlink": {
          "serverAddress": "114.255.186.218",
          "httpsServerPort": "8443",
          "serverPort": "5061",
          "model": 1
        },
        "voip": {
          "domain": "xtbg-dev.jdcloud.com",
          "port": "10002"
        },
        "im": {
          "tls": true,
          "host": "xtbg-dev.jdcloud.com/im-ws/",
          "apHost": "xtbg-dev.jdcloud.com:10001",
          "apPort": 10001,
          "chatReeditTime": 300000,
          "chatRevokeTime": 14400000,
          "chatRevokeTime2": 86400000,
          "chatInviteRevokeTime": 14400000,
          "forwardlimit_session": 10,
          "forwardlimit_messages": 20,
          "fileExpiredTime": 0,
          "maxAttentionNum": 20,
          "httpMatchList": [
            "mp.weixin.qq.com",
            "smart.swj.beijing.gov.cn",
            "m.btime.com",
            "www.btime.com",
            "item.btime.com"
          ],
          "aggregateDuration": 172800000
        },
        "jbrtc": {
          "meetApiUrl": "https://jrtc-meeting.jdcloud.com",
          "rtcServerUrl": "jrtc-interiorapi.jdcloud.com"
        },
        "helpUrl": "https://jzb.beijing.gov.cn/helper",
        "xylink": {
          "extID": "d8e08778cd33b3ae6860f1b13e9f1a68ca2f7d08",
          "proxy": "114.255.186.212:7443"
        },
        "name": "生产环境",
        "me": {
          "mainEntry": {
            "protocol": "https",
            "host": "xtbg-dev.jdcloud.com"
          }
        },
        "key": "prod",
        "gateway": {
          "protocol": "https",
          "appId": "hr3feu3hHPiQXL1fitO2",
          "webAppId": "94XNeuscQUY2Yj4E0xtm",
          "host": "xtbg-dev.jdcloud.com/janus",
          "stage": "PROD"
        },
        "aiConfig": {
          "aiUser": {
            "pin": "aiRobot",
            "teamId": "focus.bot",
            "app": "dd.notice",
            "name": "AI助手",
            "nickName": "AI助手",
            "avatar": "https://xtbg-dev.jdcloud.com/statics/images/icon-ai-robot.png"
          },
          "filterTabList": [
            {
              "pin": "~me69",
              "app": "dd.notice",
              "teamId": "focus.bot",
              "name": "日程"
            },
            {
              "pin": "eopen-push_PZzzvgDrpZVAefKImEfo",
              "app": "dd.notice",
              "teamId": "focus.bot",
              "name": "任务"
            },
            {
              "pin": "~joyspace",
              "app": "dd.notice",
              "teamId": "focus.bot",
              "name": "文档协同"
            }
          ],
          "tabList": [
            {
              "pin": "~me69",
              "app": "dd.notice",
              "teamId": "focus.bot",
              "name": "日程"
            },
            {
              "pin": "eopen-push_PZzzvgDrpZVAefKImEfo",
              "app": "dd.notice",
              "teamId": "focus.bot",
              "name": "任务"
            },
            {
              "pin": "~joyspace",
              "app": "dd.notice",
              "teamId": "focus.bot",
              "name": "文档协同"
            },
            {
              "pin": "eopen-push_0Gl8b1I3si21n0VVNkrF",
              "app": "dd.notice",
              "teamId": "focus.bot",
              "name": "催办"
            },
            {
              "pin": "eopen-push_qhTSqJ4pYYjuK7ZlYXg5",
              "app": "dd.notice",
              "teamId": "focus.bot",
              "name": "组通知"
            },
            {
              "pin": "other-notice",
              "app": "dd.notice",
              "teamId": "focus.bot",
              "name": "其他"
            }
          ],
          "ver": 6
        },
        trackConfig: {
          sendDelayTime: 10
        },
        netCheckConfig: {
          throttleTime: 10000
        },
        quickReply: {
          trigger: 0,
          keyword: [
              "收到请回复",
              "请回复收到",
              "回复"
          ],
          ownerReply: false,
          replyText: "收到",
          duration: 777600000,
          rightOpenReply: true
        }
      },
      {
        app: {
          entry: "https://jzb-pre.jdcloud.com/client",
          feedUrl: "https://jzb-oss.com/installer_releases/jdcloud_beta_x64/",
          feedUrl32:
            "https://jzb-oss.com/installer_releases/jdcloud_beta_ia32/",
          forceUpgradeVersion: "1.0.0",
          appStoreAppKey: "b96a8ab3197544e68c9919667afe9f41",
          withCALogin: true,
          CALoginUrl:
            "http://223.70.139.221:1993/am/oauth2/authorize?service=initService&amp;response_type=code&amp;client_id=d73l43gdvstsi8mx2iqs&amp;scope=all&amp;redirect_uri=https://jzb-pre.jdcloud.com/login/ca-callback&amp;model=cs&amp;decision=Allow&amp;hotpFowardModel=mobile"
        },
        webConfig: {
          routeBase: "/client",
          ssoLoginUrl: "https://jzb-pre.jdcloud.com/passport/",
          ssoClientId: "4d571c78c9df4830b0505b3b03dfbce5",
          qrLoginUrl: "https://me-pre.jdcloud.com/passport/"
        },
        joyspace: {
          protocol: "https",
          wpsTarget: "private",
          cookie: {
            domain: ".jdcloud.com"
          },
          host: "jzb-joyspace-pre.jdcloud.com",
          lowCode: {
            createUrl: "https://jzb-joybuilder-pre.jdcloud.com/#/form/create"
          },
          pageTypes: {
            page: {
              value: 1,
              routeTag: "document_edit"
            },
            sheet: {
              value: 4,
              routeTag: "spreadsheet_edit"
            },
            file: {
              value: 6,
              routeTag: "file_view"
            },
            mind: {
              value: 10,
              routeTag: "mind"
            }
          }
        },
        fileService: {
          appKey: "41d47591b3adf037",
          imAppKey: "1mgfxqcb9nkj3f05",
          imNoDeleteAppKey: "tgAy7FMYQmJLUdmK",
          groupNoticeAppKey: "jAYNzavPLsn6aYJf",
          avatarAppKey: "3jlr7bx56nhitdb9",
          hostOrigin: "https://jzb-eefs-pre.jdcloud.com",
          joyspaceAppKey: "966df28278a65b20"
        },
        joyspaceApi: {
          protocol: "https",
          host: "jzb-apijoyspace-pre.jdcloud.com"
        },
        open: {
          protocol: "https",
          host: "jzb-open-pre.jdcloud.com"
        },
        zoom: {
          domain: "https://jdmeeting.jd.com",
          api: "https://api-external-joymeeting.jd-eit.com/kk/tellme",
          sdkId: "OwcSrKQSfCpGZyf3y7YncWDAzPxhAz1j",
          sk: "8hRfOqen*x9X3jz2KWhTI#0aAo%oe4We"
        },
        hwlink: {
          serverAddress: "114.255.186.218",
          httpsServerPort: "8443",
          serverPort: "5061",
          model: 1
        },
        voip: {
          domain: "jzb-rtc-ap-pre.jdcloud.com",
          port: "443"
        },
        im: {
          tls: true,
          host: "jzb-im-ws-test.jdcloud.com",
          apHost: "jzb-im-ap-test.jdcloud.com",
          apPort: 10001,
          chatReeditTime: 14400000,
          chatRevokeTime: 14400000,
          chatRevokeTime2: 86400000,
          chatInviteRevokeTime: 300000,
          forwardlimit_session: 10,
          forwardlimit_messages: 20,
          fileExpiredTime: 0,
          maxAttentionNum: 20,
          httpMatchList: [
            "mp.weixin.qq.com",
            "smart.swj.beijing.gov.cn",
            "m.btime.com",
            "www.btime.com",
            "item.btime.com"
          ]
        },
        name: "应用接入环境",
        me: {
          mainEntry: {
            protocol: "https",
            host: "jzb-pre.jdcloud.com"
          }
        },
        key: "beta",
        gateway: {
          protocol: "https",
          appId: "hr3feu3hHPiQXL1fitO2",
          webAppId: "94XNeuscQUY2Yj4E0xtm",
          host: "jzb-janus-pre.jdcloud.com",
          stage: "PRE"
        },
        aiConfig: {
          aiUser: {
            pin: "aiRobot",
            teamId: "focus.bot",
            app: "dd.notice",
            name: "AI 助手",
            nickName: "AI 助手",
            avatar:
              "https://focus-desktop.s3.cn-north-1.jdcloud-oss.com/statics/icons/icon-ai-robot.png"
          },
          tabList: [
            {
              pin: "~me69",
              app: "dd.notice",
              teamId: "focus.bot",
              name: "日程"
            },
            {
              pin: "eopen-push_PZzzvgDrpZVAefKImEfo",
              app: "dd.notice",
              teamId: "focus.bot",
              name: "任务"
            },
            {
              pin: "~joyspace",
              app: "dd.notice",
              teamId: "focus.bot",
              name: "文档协同"
            },
            {
              pin: "eopen-push_0Gl8b1I3si21n0VVNkrF",
              app: "dd.notice",
              teamId: "focus.bot",
              name: "提醒"
            },
            {
              pin: "eopen-push_qhTSqJ4pYYjuK7ZlYXg5",
              app: "dd.notice",
              teamId: "focus.bot",
              name: "组通知"
            },
            {
              pin: "other-notice",
              app: "dd.notice",
              teamId: "focus.bot",
              name: "其他"
            }
          ],
          ver: 3
        }
      }
    ],
    "appId": "com.jd.ee.me.client.xtbg",
    "upgradeVersionInfo": [
      "增加个人可扫码添加联系人功能",
      "升级任务体验并支持推进记录显示",
      "提升催办分类体验",
      "增加仅自己可见的备注功能",
      "优化日程细节体验",
      "修复其他已知问题，提升体验"
    ],
    "productName": "协同办公",
    "i18n": {
      "en_US": {
        "layout": {
          "nav": {
            "calendar": "Calendar",
            "joyspace": "Joyspace",
            "ebook": "Contacts",
            "tests": "TestPage",
            "thirdApp": "Application",
            "messages": "Message",
            "joywork": "JoyWork"
          }
        },
        "login": {
          "title": "欢迎使用 {{productName}}",
          "desc": "与你的团队和朋友在{{productName}}中进行交流与协作"
        }
      },
      "zh_CN": {
        "layout": {
          "nav": {
            "calendar": "日历",
            "meeting": "音视频",
            "joyspace": "文档协同",
            "ebook": "通讯录",
            "tests": "测试页",
            "thirdApp": "工作台",
            "messages": "消息",
            "joywork": "任务"
          }
        },
        "login": {
          "title": "欢迎使用 {{productName}}",
          "desc": "与您的团队和朋友在{{productName}}中进行交流与协作"
        }
      }
    }
  },
  "key": "xtbg",
  "name": "协同办公"
}];